export default "__VITE_ASSET__3339c262__"